/**
 * Positiv innsjekk-streak (UX-prinsipp #6 tapsaversjon, grep C — se
 * docs/plan-ux-principles-retention.md). Bevisst SKYLDFRI: vi teller sammenhengende
 * uker med minst én innsjekk som noe brukeren EIER og bygger (endowment, kobler til #4),
 * ikke en Duolingo-straffeteller. Er rekka brutt, viser vi den bare ikke — ingen rødt,
 * ingen «du mistet rekka!». Innenfor gissel-grensen (feedback_honest_persuasion_rules).
 *
 * Ren og tidsuavhengig (now injiseres) → fullt testbar. Uker er faste 7-døgns-bøtter
 * fra epoch; grensen er vilkårlig men konsistent, som er alt en streak-teller trenger.
 *
 * Nåde: rekka regnes fortsatt aktiv hvis siste innsjekk var forrige uke (du har ennå
 * ikke rukket å sjekke inn denne uka) — så den ikke «brekker» midt i en aktiv uke.
 */

export const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

export interface CheckinStreak {
  /** Antall sammenhengende uker med minst én innsjekk, fram til nå (med nåde). */
  weeks: number;
  /** Har brukeren en levende rekke akkurat nå? */
  isActive: boolean;
}

function weekIndex(ts: number): number {
  return Math.floor(ts / WEEK_MS);
}

export function computeCheckinStreak(visitTimestamps: number[] = [], now: number): CheckinStreak {
  if (visitTimestamps.length === 0) return { weeks: 0, isActive: false };

  const weeksWithCheckin = new Set(visitTimestamps.map(weekIndex));
  const currentWeek = weekIndex(now);

  // Forankre rekka: denne uka hvis mulig, ellers forrige uke (nåde). Er ingen av dem
  // dekket, er rekka brutt → 0 (og vi viser den ikke).
  let anchor: number;
  if (weeksWithCheckin.has(currentWeek)) anchor = currentWeek;
  else if (weeksWithCheckin.has(currentWeek - 1)) anchor = currentWeek - 1;
  else return { weeks: 0, isActive: false };

  let weeks = 0;
  while (weeksWithCheckin.has(anchor - weeks)) weeks++;

  return { weeks, isActive: weeks > 0 };
}
